import { render, staticRenderFns } from "./NotificationTag.vue?vue&type=template&id=7e7845cc"
import script from "./NotificationTag.vue?vue&type=script&lang=js"
export * from "./NotificationTag.vue?vue&type=script&lang=js"
import style0 from "./NotificationTag.vue?vue&type=style&index=0&id=7e7845cc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports